import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class RegistryUploadJobService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.REGISTRY_UPLOAD_JOB = '/api/registry-upload-job';

        this.GET_BY_ID = '/{id}';
        this.GET_LIST_FILTERED = '/filtered';
        this.GET_LIST_BY_RUN_ID = '/list/run-id/{runId}';
        this.EXPORT_RECORDS = '/export';
    }

    async getById(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_UPLOAD_JOB + this.GET_BY_ID;
        url = url
            .replace('{id}', id);
        try{
            const registryUploadRunStatus = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return registryUploadRunStatus;
        } catch(err) {
            console.log(err);
        }
    }

    async getRegistryUploadJobListByRunId(runId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_UPLOAD_JOB + this.GET_LIST_BY_RUN_ID;
        url = url
            .replace('{runId}', runId);
        try{
            const registryUploadJobList = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return registryUploadJobList;
        } catch(err) {
            console.log(err);
        }
    }

    async getFilteredRegistryUploadJob(filterObj) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_UPLOAD_JOB + this.GET_LIST_FILTERED;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterObj)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async exportRecords(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_UPLOAD_JOB + this.EXPORT_RECORDS;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default RegistryUploadJobService;